import React from 'react';
import { Link } from 'react-router-dom';
import { SvgIcon } from 'core/icons';
import { combineClassNames } from 'core/css';
import computeMoreViewsPath from '../../utils/computeMoreViewPath';

const MoreViewsButton = ({
  inverted = false,
  className,
  analyticsKey,
  step,
}) => {
  const moreViewsPath = computeMoreViewsPath(step);

  return (
    <Link
      className={combineClassNames(
        `more-views-btn${inverted ? ' more-views-btn--inverted' : ''}`,
        className,
        'stat-button-link'
      )}
      to={{
        pathname: moreViewsPath.pathname,
        search: moreViewsPath.search,
      }}
      data-dtm={analyticsKey}>
      <div className="more-views-btn__control">
        <SvgIcon className="svg-icon--option" name="more-views" />
      </div>
    </Link>
  );
};

export default MoreViewsButton;
